"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageStatusEnum = exports.ResponseMessagesWithMeta = exports.MetaResponseMessages = void 0;
class MetaResponseMessages {
    constructor({ page, itemCount, limit, chatId }) {
        this.chatId = chatId;
        this.page = page ? page + 1 : 1;
        const pageCount = Math.ceil(itemCount / limit);
        this.hasNextPage = this.page < pageCount;
    }
}
exports.MetaResponseMessages = MetaResponseMessages;
class ResponseMessagesWithMeta {
    constructor(data, meta) {
        this.data = data;
        this.meta = meta;
    }
}
exports.ResponseMessagesWithMeta = ResponseMessagesWithMeta;
var MessageStatusEnum;
(function (MessageStatusEnum) {
    MessageStatusEnum["UNREAD"] = "Unread";
    MessageStatusEnum["READ"] = "Read";
    MessageStatusEnum["ERROR"] = "Error";
    MessageStatusEnum["SENT"] = "Sent";
})(MessageStatusEnum || (exports.MessageStatusEnum = MessageStatusEnum = {}));
//# sourceMappingURL=message.interface.js.map